require('./bootstrap');
require('./components/translate');
require('./classes/form');
require('./classes/notification');
require('./dashboard/components/cookie');
require('./custom');
require('masonry-layout/dist/masonry.pkgd');
require('./components/social-share');

//import Alpine from 'alpinejs';
import Form from './classes/form';
import Notification from './classes/notification';
import {initializeCountryRegionSelector} from './components/crs';
import Load from "./components/load";

window.Load = Load;
window.Form = Form;
window.Notification = Notification;

require('dropzone/dist/dropzone-min');
require('./components/social-share');

require('lightgallery');
require('lightgallery/plugins/thumbnail');
require('lightgallery/plugins/zoom');
require('vanilla-cookieconsent');
require('./components/cookie-consent');
require('./components/prevent-input');
require('./components/form-enter-submit');

import {initializeDateTimePicker} from './components/daterangepicker';

import {initializeSocialButtonShare} from './components/social-share';

import lightGallery from 'lightgallery';

// Plugins
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'

window.lightGallery = lightGallery;

$(document).ready(function () {
    initializeDateTimePicker();
    initializeCountryRegionSelector();
    initializeSocialButtonShare();
});

/**
 * Submit a form using form ajax
 */
$(document).on('submit', 'form', function (e) {
    let form = new Form($(this));
    form.loadingAnimation(true);
    if ($(this).data('refresh') !== false) {
        e.preventDefault();
        formAjax($(this));
    }
});
